import { ref } from 'vue';
import { defineStore } from 'pinia';
import { useKioskStore } from '@/stores/useKioskStore'

export const useIdleStore = defineStore('idle', () => {
	const kioskStore = useKioskStore();

	const isDevMode = ref(false);
	const isModalVisible = ref(false);

	let timeoutId = null;
	let alertTimeoutId = null;

	const startTimer = () => {
		if (isDevMode.value) return;
		clearTimers();

		const timeout = (kioskStore.timeout || 30) * 1000;

		timeoutId = window.setTimeout(() => {
			isModalVisible.value = true;

			alertTimeoutId = window.setTimeout(() => {
				if (isModalVisible.value) {
					// TODO: What must be shown?
					alert('Show video preview');
				}
			}, 10000);
		}, timeout);
	}

	const resetTimer = () => {
		if (isDevMode.value) return;
		startTimer();
	}

	const clearTimers = () => {
		if (timeoutId) {
			clearTimeout(timeoutId);
			timeoutId = null;
		}
		if (alertTimeoutId) {
			clearTimeout(alertTimeoutId);
			alertTimeoutId = null;
		}
	}

	const continueUsage = () => {
		isModalVisible.value = false;
		startTimer();
	}

	const cancelUsage = () => {
		clearTimers();
		window.location.href = `/${kioskStore.kioskId}`;
		alert('Show video preview');
	}

	const setDevMode = (value) => {
		isDevMode.value = value;
	};

	return {
		isDevMode,
		isModalVisible,
		startTimer,
		resetTimer,
		clearTimers,
		continueUsage,
		cancelUsage,
		setDevMode,
	}
});
